<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-skeleton
      :row="30"
      :loading="loading"
      style="margin-top: 1em;"
    >
      <div class="pageBody" v-html="body" />
    </van-skeleton>

  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey } from '@/utils/base'
import { Skeleton } from 'vant'
export default {
  components: {
    [Skeleton.name]: Skeleton,
    TopBar
  },
  data() {
    return {
      showbody: undefined,
      body: undefined,
      title: '',
      backurl: '/home/index',
      loading: true
    }
  },
  created() {
    initPage(false)
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.showbody = this.$route.params.code
    request({
      url: '/data/getPage',
      method: 'post',
      params: {
        code: this.showbody
      }
    }).then(response => {
      this.loading = false
      if (response.success) {
        this.body = response.data.body
        this.title = response.data.title
      } else {
        this.body = '无内容'
        this.title = '空页面'
      }
    })
  },
  methods: {
  }
}
</script>

<style scoped>
.pageBody{
  padding: 0 1em;

}
</style>
